import React, {Component} from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import FormGroup from '@spothero/ui/form-group';
import FormGroupError from '@spothero/ui/form-group-error';
import Label from '@spothero/ui/label';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import TextInput from '@spothero/ui/text-input';
import ValidationUtils from '@spothero/utils/validation';
import AuthenticationUtils from 'utils/authentication';

export default class FacebookEmailModal extends Component {
    static propTypes = {
        onHidden: PropTypes.func.isRequired,
        referralSource: PropTypes.string
    };
    state = {
        formError: null,
        isLoading: false
    };

    _onSubmit = evt => {
        const {
            email
        } = serialize(evt.target, {hash: true});

        this.setState({
            formError: null,
            isLoading: true
        });

        AuthenticationUtils.logInFacebook({
            email,
            referralSource: this.props.referralSource,
            onFailure(errors) {
                this.setState({
                    formError: 'Whoops, something went wrong. Please try again.',
                    isLoading: false
                });
            }
        });
    }

    render() {
        const {
            onHidden
        } = this.props;
        const {
            isLoading,
            formError
        } = this.state;

        return (
            <Modal
                className="FacebookEmailModal"
                title="No Email Found"
                onHidden={onHidden}
                width="slim"
            >
                <ModalContent>
                    <p><strong>Your Facebook account doesn&apos;t have an email address.</strong> Please provide your email address to complete your SpotHero account.</p>
                    <Form
                        id="FacebookEmailModal-form"
                        onSubmit={this._onSubmit}
                    >
                        <FormGroup>
                            <TextInput
                                type="email"
                                name="email"
                                label={<Label>Email</Label>}
                                pattern={ValidationUtils.EMAIL}
                                error={<FormElementError>Please enter a valid email.</FormElementError>}
                                required
                                focus
                            />
                        </FormGroup>
                        <div className="FormActions">
                            <Button
                                color="primary"
                                type="submit"
                                loading={isLoading}
                                disabled={isLoading}
                            >
                                Submit
                            </Button>
                        </div>
                        {formError &&
                            <FormGroupError>
                                {formError}
                            </FormGroupError>
                        }
                    </Form>
                </ModalContent>
            </Modal>
        );
    }
}
